export default __webpack_public_path__ + "static/media/logo_white.1d5f65ab.svg";